import React, { Component } from 'react';
import Footer from './Footer';
import styled from 'styled-components';

const P = styled.p`
  font-size: 1.1em;
`

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    return (
      <div className="container">
        <h3>About Envelope</h3>
        <hr />
        <div className="test" style={{ textAlign: "center" }}>
        <iframe src="https://player.vimeo.com/video/235359422?title=0&byline=0&portrait=0&autoplay=true"
            width="600" height="338" frameBorder="0" allowFullScreen></iframe>
        </div>
        <hr />
        <h4>A back of the envelope, with benefits.</h4>
        <P>Read more on <a href="https://medium.com/@sventies/introducing-envelope-2-8734e785f5b3">this Medium arctice</a>.</P>
        <P>Envelope is a place where people can create and share visualisation tools. It leverages modern
            browser capabilities and makes it super easy to get quick insights into your data, and share your
            insights with the rest of the world. </P>
        <P>It can be used for presentations, calculations, visualisation,
            sketching, communication and much, much more. Really think of Envelope
            as the back of your envelope, but with the benefits of a modern digital and connected tool.</P>
        <P>The browser of today is capable of more than
            your whole computer could do only 20 years ago. We believe that Envelope
            can reach a lot of use cases for a lot of people working in business, engineering,
            design or education, and all you need is a laptop and internet connection.</P>
        <P>Interested? <a href="/" onClick={(e) => {e.preventDefault(); this.props.signUp();}}>Sign up for free!</a></P>
        <P> Wanna know more?
          <a href="mailto:info@envelope.li?Subject=Request%20for%20Information" target="_top"> Send us an email.</a> </P>
        <hr/>
        <h4>Custom Work</h4>
        <P>Envelope can be used for free, to share your creations with the rest of the world. You can also use Envelope
            to pick the tool that you want. We're building features to privately save your envelopes, export to presentations and much much more. </P>
        <P>But it could happen that you don't find what you want. You may want your data in an environment that is not accessible to the
          whole world. Or you want user interaction to be saved to a backend. Or maybe you have some idea what you want, but don't know how to make
          it yourself. We can build custom work for you. Below are some examples of what may be reasons to reach out to us for custom work:</P>
          <P><ul>
            <li>You want to save user-entered data to a backend</li>
            <li>Your data format is too complex or too big to fit in a spreadsheet interface</li>
            <li>You need to interact with external API's</li>
            <li>You have highly detailed stylistic requirements (huis stijl)</li>
            <li>You and your team miss the technical skills to make visualisations work for you</li>
          </ul></P>
          <P>
          Do you feel that you may want some help? We're happy to help you. <a href="mailto:info@envelope.li?Subject=Request%20for%20Information" target="_top"> Get in touch </a>! </P>
          <hr />
          <h4>Anything Else</h4>
          <P>You like the site but you really need this one feature to go live? You're a developer but you're struggling with the API? You want to tell about Envelope but you're not
            sure where to start? Or any other questions? We're happy to hear you feedback!</P>

        <Footer />

      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js